<div class="table-responsive max-h254">
    <table class="tablest1">
      <thead>
        <tr>
          <th style="width: 55px" scope="col"></th>
          <th style="width: 55px" scope="col">#</th>
          <th scope="col" class="text-right" translate>
            lblMechanicNumber
          </th>
          <th scope="col" class="text-right" translate>
            lblMechanicName
          </th>
          <th scope="col" class="text-right" translate >
            lblStampIn
          </th>
          <th scope="col" class="text-right" translate>
            lblStampOut
          </th>
          <th scope="col" class="text-right" translate>
            lblStandardTime
          </th>
          <th scope="col" class="text-right" translate>
            lblTimeConsumed
          </th>
        </tr>
      </thead>

      <tbody>
        <ng-container *ngIf="
        timeStampDetails?.length > 0;
          else load_NotFound_Template
        ">
        <ng-container *ngFor="let item of timeStampDetails; let i = index">
          <tr >
            <td style="width:30px" class="pr-0" (click)="item.expanded = !item.expanded">
              <a class="btn btn-ico" ngbTooltip="Show CheckList Item" tooltipClass="custom-revert" *ngIf="item.timeStampDetails?.length">
                  <em class="fas fa-chevron-right fa-lg" [ngClass]="{'fa-chevron-up': item.expanded}"></em>
              </a>
            </td> 
            <td>{{ i + 1 }}</td>
            <td style="width:100px">
              <ngb-highlight [result]="item.mechanicNumber || ''"> </ngb-highlight>
            </td>
            <td style="width:100px">
              <ngb-highlight [result]="item.name || ''"> </ngb-highlight>
            </td>
            <td class="text-right">
              <div>
                <ngb-highlight [result]="getFormattedDate(item.stampIn)"> </ngb-highlight>
              </div>
            </td>
            <td class="text-right">
              <div>
                <ngb-highlight [result]="getFormattedDate(item.stampOut)"> </ngb-highlight>
              </div>
            </td>
            <td class="text-right">
              <div>
                <ngb-highlight [result]="item.totalTime || ''"> </ngb-highlight>
              </div>
            </td>
            <td class="text-right">
              <div>
                <ngb-highlight [result]="item.timeConsumed || ''"> </ngb-highlight>
              </div>
            </td>
          </tr>
          <ng-container *ngIf="item.expanded">
            <tr class="table-active">
              <td colspan="8" class="p-2 pl47">

                <table class="tablest1 border">
                  <tr class="checkListItems" *ngIf="item.timeStampDetails?.length>0;else load_else">

                    <th style="width: 55px" scope="col">#</th>
                    <th scope="col" style="width: 100px" translate>lblWoNo</th>
                    <th scope="col" class="text-right" translate>
                      lblJobNo
                    </th>
                    <th scope="col" class="text-right" translate>
                      lblTimeCode
                    </th>
                    <th scope="col" class="text-right" translate>
                      lblStartTime
                    </th>
                    <th scope="col" class="text-right" translate>
                      lblEndTime
                    </th>
                    <th scope="col" class="text-right" translate>
                      lblTimeConsumed
                    </th>

                  </tr>
                  <tr *ngFor="let element of item.timeStampDetails; let i=index" class="checkListItems">

                    <td>{{ i + 1 }}</td>
                    <td style="width:100px">
                      <ngb-highlight [result]="element.workOrderNo || ''"> </ngb-highlight>
                    </td>
                    <td class="text-right">
                      <div>
                        <ngb-highlight [result]="element.appointmentJobId || ''">
                        </ngb-highlight>
                      </div>
                    </td>
                    <td class="text-right">
                      <div>
                        <ngb-highlight [result]="element.timeCode || ''">
                        </ngb-highlight>
                      </div>
                    </td>
                    <td class="text-right">
                      <div>
                        <ngb-highlight [result]="getFormattedDate(element.startTime)"> </ngb-highlight>
                      </div>
                    </td>
                    <td class="text-right">
                      <div>
                        <ngb-highlight [result]="getFormattedDate(element.endTime)"> </ngb-highlight>
                      </div>
                    </td>
                    <td class="text-right">
                      <div>
                        <ngb-highlight [result]="element.timeConsumed || ''"> </ngb-highlight>
                      </div>
                    </td>

                  </tr>
                  <ng-template #load_else>
                    <tr>
                      <td colspan="7" class="no-record" translate>
                        lblNoRecordsFound
                      </td>
                    </tr>
                  </ng-template>
                </table>

              </td>
            </tr>

          </ng-container>
        </ng-container>
        </ng-container>
        <ng-template #load_NotFound_Template>
          <tr>
            <td colspan="8" class="no-record" translate>
              lblNoRecordsFound
            </td>
          </tr>
        </ng-template>
      </tbody>
    </table>
  </div>